var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextjsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 81,
    viewBox: "0 0 119 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5347 21.0286H56.7417V23.0323H33.8454V38.1111H55.3765V40.1145H33.8454V56.6696H57.0043V58.673H31.5347V21.0286ZM59.0001 21.0286H61.6782L73.5464 37.5838L85.6771 21.0284L102.177 0L75.0692 39.3238L89.0381 58.673H86.2548L73.5464 41.0636L60.7852 58.673H58.0546L72.1285 39.3236L58.9998 21.0286H59.0001ZM90.0357 23.0323V21.0284H118.761V23.032H105.527V58.6727H103.217V23.0323H90.0357ZM0 21.0284H2.88827L42.7159 80.627L26.2573 58.6727L2.41555 23.8757L2.31062 58.6733H0V21.0284ZM118.528 56.0646C118.056 56.0646 117.702 55.6991 117.702 55.2261C117.702 54.7537 118.056 54.3877 118.528 54.3877C119.006 54.3877 119.355 54.7534 119.355 55.2261C119.355 55.6989 119.006 56.0646 118.528 56.0646ZM120.799 53.8589H122.035C122.052 54.5284 122.541 54.9787 123.26 54.9787C124.064 54.9787 124.519 54.4947 124.519 53.5887V47.8487H125.778V53.5942C125.778 55.2261 124.834 56.1661 123.272 56.1661C121.805 56.1661 120.799 55.2543 120.799 53.8586V53.8589ZM127.425 53.7858H128.673C128.779 54.5566 129.532 55.046 130.617 55.046C131.629 55.046 132.371 54.5227 132.371 53.8025C132.371 53.1836 131.898 52.8122 130.825 52.559L129.78 52.3058C128.313 51.9622 127.644 51.2533 127.644 50.0604C127.644 48.6143 128.824 47.6519 130.594 47.6519C132.241 47.6519 133.444 48.614 133.517 49.9816H132.292C132.174 49.2332 131.522 48.766 130.577 48.766C129.583 48.766 128.92 49.2444 128.92 49.9758C128.92 50.5553 129.347 50.8876 130.403 51.1351L131.297 51.3546C132.96 51.743 133.646 52.4183 133.646 53.6394C133.646 55.1925 132.444 56.1661 130.522 56.1661C128.723 56.1661 127.515 55.2374 127.425 53.7855V53.7858Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 54,
    width: 2,
    height: 3,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 81,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjsLogo);
export default __webpack_public_path__ + "static/media/nextjs_logo.eb5a3aae1fbd3b659db2e121c8bd7fbd.svg";
export { ForwardRef as ReactComponent };